import { showErrorMessage, showSuccessMessage } from "../../common/Toaster";
import { USER_LIST_SUCCESS } from "../../constants/userConstants";
import jwtAxios from "../../services/axiosInstance/ApiConfig";
import { topSellersResponse } from "../../services/dbs/bazzarey_dbs";
import { FETCH_START, FETCH_SUCCESS, FETCH_ERROR } from "../types/actions/Common.actions";
import { SET_ALL_CUSTOMERS, SET_TOP_SELLERS } from "../types/actions/ProductAction";
import { getHeaders } from "./Auth";

export const onGetTopSeller = () => {
	return async (dispatch: any) => {
		try {
			dispatch({ type: FETCH_START })
			const resp = await jwtAxios.get('/users/top-sellers')
			if (resp && resp.status === 200) {
				dispatch({ type: FETCH_SUCCESS })
                dispatch({ type: SET_TOP_SELLERS, payload: resp.data })
				dispatch({ type: USER_LIST_SUCCESS, payload: resp.data })
			} else {
				showErrorMessage('Something went wrong!')
			}
		} catch (err: any) {
			console.log("err ", err)
			if(err.code === "ERR_NETWORK")
				dispatch({ type: SET_TOP_SELLERS, payload: topSellersResponse })
			else {
				dispatch({ type: FETCH_ERROR, error: err })
				showErrorMessage(err.response.data.detail)
			}
		}
	};
};

export const onUpdateSeller = (id: string, payload: any) => {
	return async (dispatch: any) => {
		try {
			const resp = await jwtAxios.put('/users/update-seller/' + id, payload, {
				headers: getHeaders()
			})
			if (resp && resp.status === 200) {
				dispatch(onGetTopSeller())
				showSuccessMessage('User updated successfully!')
			} else {
				showErrorMessage('Something went wrong!')
			}
		} catch (err: any) {
			showErrorMessage(err.response.data.message)
		}
	}
}

export const onGetAllCustomers = () => {
	return async (dispatch: any) => {
		try {
			dispatch({ type: FETCH_START })
			const resp = await jwtAxios.get('/users/all-customers')
			if (resp && resp.status === 200) {
				dispatch({ type: FETCH_SUCCESS })
                dispatch({ type: SET_ALL_CUSTOMERS, payload: resp.data })
			} else {
				showErrorMessage('Something went wrong!')
			}
		} catch (err: any) {
			console.log("err ", err)
			dispatch({ type: FETCH_ERROR, error: err })
			showErrorMessage(err.response.data.detail)
		}
	};
};
